// // TableForUserEdit.jsx
// import React, { useState, useEffect, useMemo } from "react";
// import { Link } from "react-router-dom";
// import updown from "../../Assets/Images/CommanImages/updown.png";
// import Filter from "../../Assets/Images/CommanImages/filter.png";
// import leftArrow from "../../Assets/Images/CommanImages/Larrowbar.png";
// import rightArrow from "../../Assets/Images/CommanImages/Rarrowbar.png";
// import "katex/dist/katex.min.css";
// import searchicon from "../../Assets/Images/CommanImages/searchyellow.png";

// /**
//  * TableForUserEdit: grouped user-group table.
//  * - Group cell uses rowspan = number of roles
//  * - One <tr> per role (so screens/reports for a role are grouped)
//  * - Minimal inline style overrides applied ONLY to Screens and Reports containers
//  *   to protect them from external global rule: `td > div { display: flex; align-items: center; }`
//  *
//  * Small update: AccessBubble accepts `margin` prop and renderAccess supports `compact`.
//  * When rendering screens/reports in-table we call renderAccess(..., compact=true)
//  * so the name and bubbles appear with a small (reduced) gap between text and first bubble.
//  */

// const AccessBubble = ({ letter, title, visible, color, small = true, margin }) => {
//   if (!visible) return null;
//   const size = small ? 20 : 22;
//   const style = {
//     display: "inline-flex",
//     alignItems: "center",
//     justifyContent: "center",
//     width: `${size}px`,
//     height: `${size}px`,
//     borderRadius: "50%",
//     marginLeft: typeof margin === "number" ? margin : 6, // default 6px, can be overridden
//     fontSize: small ? 11 : 12,
//     color: "#fff",
//     fontWeight: 700,
//     backgroundColor: color,
//     lineHeight: 1,
//     flex: "0 0 auto",
//   };
//   return (
//     <span className={`uge-bubble uge-bubble-${letter}`} title={title} style={style}>
//       {letter}
//     </span>
//   );
// };

// const TableForUserEdit = ({
//   headers = [],
//   data = [],
//   searchPlaceholder = "Search...",
//   selectedRows = [],
//   setSelectedRows = () => {},
//   renderQuestionText = (t) => t,
//   renderQuestionTextModel = (t) => t,
//   expandedStates = {},
//   toggleImage = () => {},
//   questionDetailsMap = {},
//   handleEyeClick = () => {},
//   pageType = "default",
//   onRowLinkClick = () => {},
//   filterConfig = {},
//   handleDeleteRow = () => {},
//   disabled = false,
// }) => {
//   const [searchQuery, setSearchQuery] = useState("");
//   const [visibleColumns, setVisibleColumns] = useState([]);
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);

//   useEffect(() => {
//     if (headers.length > 0 && visibleColumns.length === 0) setVisibleColumns([...headers]);
//   }, [headers, visibleColumns.length]);

//   const rowToString = (row) => {
//     if (!row) return "";
//     return [
//       row.group_name,
//       ...(row.roles || []).flatMap((r) => [r.role_name, ...(r.screens || []).map((s) => s.screen_name), ...(r.reports || []).map((rp) => rp.report_name)]),
//     ]
//       .filter(Boolean)
//       .join(" ")
//       .toLowerCase();
//   };

//   const filteredData = data.filter((row) => {
//     const text = rowToString(row);
//     return !searchQuery || text.includes(searchQuery.toLowerCase());
//   });

//   const sortedData = useMemo(() => {
//     let arr = [...filteredData];
//     if (sortConfig.key) {
//       arr.sort((a, b) => {
//         const getVal = (r) => (sortConfig.key === "User Groups" ? r.group_name : (r.roles || []).map((x) => x.role_name).join(", "));
//         const va = getVal(a);
//         const vb = getVal(b);
//         if (va < vb) return sortConfig.direction === "asc" ? -1 : 1;
//         if (va > vb) return sortConfig.direction === "asc" ? 1 : -1;
//         return 0;
//       });
//     }
//     return arr;
//   }, [filteredData, sortConfig]);

//   const totalPages = Math.max(1, Math.ceil(sortedData.length / pageSize));
//   const paginatedData = useMemo(() => {
//     const start = (currentPage - 1) * pageSize;
//     return sortedData.slice(start, start + pageSize);
//   }, [sortedData, currentPage, pageSize]);

//   const handleSort = (column) => {
//     let dir = "asc";
//     if (sortConfig.key === column && sortConfig.direction === "asc") dir = "desc";
//     setSortConfig({ key: column, direction: dir });
//   };

//   // renderAccess now supports compact flag (third param).
//   // compact === true => bubbles will be rendered with a reduced gap between text and first bubble.
//   // We pass marginNumber (e.g., 4) to AccessBubble when compact is true.
//   const renderAccess = (access, isReport = false, compact = false) => {
//     if (!access) return null;
//     const firstGap = compact ? 4 : 6; // 4px gap when compact, otherwise 6px
//     return (
//       <div
//         className="uge-bubble-container"
//         style={{
//           display: "flex", // explicit inline style to override global td > div if it applies
//           alignItems: "center",
//           gap: 6,
//           flexWrap: "nowrap",
//         }}
//       >
//         {!isReport && <AccessBubble letter="R" visible={access.read} color="#19B24B" margin={firstGap} />}
//         {!isReport && <AccessBubble letter="U" visible={access.update} color="#FF9800" margin={firstGap} />}
//         {!isReport && <AccessBubble letter="D" visible={access.delete} color="#E53935" margin={firstGap} />}
//         {!isReport && <AccessBubble letter="C" visible={access.create} color="#C3EA3D" margin={firstGap} />}
//         <AccessBubble letter="P" visible={access.print} color="#25A9E0" margin={firstGap} />
//         <AccessBubble letter="DL" visible={access.download} color="#7E8DA6" margin={firstGap} />
//       </div>
//     );
//   };

//   const [detailsModal, setDetailsModal] = useState({ visible: false, type: null, payload: null });
//   const openGroupModal = (groupRow) => setDetailsModal({ visible: true, type: "group", payload: groupRow });
//   const openRoleModal = (groupRow, roleObj) => setDetailsModal({ visible: true, type: "role", payload: { ...roleObj, group_name: groupRow.group_name } });
//   const closeDetailsModal = () => setDetailsModal({ visible: false, type: null, payload: null });

//   return (
//     <div className="uge-table-wrapper" style={{ width: "100%" }}>
//       {/* top controls */}
//       {/* <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//         <div style={{ display: "flex", alignItems: "center", width: "490px" }} />
//         <div style={{ textAlign: "end", color: "#424242" }}>
//           Displaying {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} - {Math.min(currentPage * pageSize, sortedData.length)} of {sortedData.length} records |
//           {["10", "25", "50", "100", "500"].map((size) => (
//             <span key={size} onClick={() => { setPageSize(Number(size)); setCurrentPage(1); }} style={{ cursor: "pointer", margin: "0 5px", textDecoration: size === String(pageSize) ? "none" : "underline", color: size === String(pageSize) ? "black" : "#337AB7" }}>
//               {size}
//             </span>
//           ))}
//         </div>
//       </div> */}

//       {/* <div style={{ display: "flex", backgroundColor: "#D6D6D6", marginTop: 9, borderTop: "1px solid grey", borderBottom: "1px solid grey" }}>
//         <div style={{ backgroundColor: "#FFBD20", display: "flex", alignItems: "center", paddingLeft: 8, width: 90 }}>
//           <img src={Filter} style={{ height: 24, width: 24 }} alt="filter" />
//           <span style={{ marginLeft: 10, color: "#2F2E40" }}>Filter</span>
//         </div>
//         <div style={{ marginLeft: "auto", marginRight: 8, display: "flex", alignItems: "center", position: "relative", height: 40 }}>
//           <img src={searchicon} alt="search" style={{ cursor: "pointer" }} />
//         </div>
//       </div> */}

//       {data.length > 0 ? (
//         <>
//           <div className="table-wrapper-cols-selections" style={{ overflowX: "auto", width: "100%" }}>
//             <table className="table-tc" style={{ width: "100%", borderCollapse: "separate" }}>
//               <thead >
//                 <tr>
//                   <td className="Heading-tc" style={{ textAlign: "left", paddingLeft: 20 }}>
//                     {visibleColumns[0] || "User Groups"}
//                     <img src={updown} onClick={() => handleSort(visibleColumns[0] || "User Groups")} alt="sort" style={{ height: 16, width: 16, marginLeft: 8 }} />
//                   </td>
//                   <td className="Heading-tc" style={{ textAlign: "left" }}>
//                     {visibleColumns[1] || "Roles"}
//                     <img src={updown} onClick={() => handleSort(visibleColumns[1] || "Roles")} alt="sort" style={{ height: 16, width: 16, marginLeft: 8 }} />
//                   </td>
//                   <td className="Heading-tc" style={{ textAlign: "left" }}>
//                     {visibleColumns[2] || "Screens"}
//                     <img src={updown} onClick={() => handleSort(visibleColumns[2] || "Screens")} alt="sort" style={{ height: 16, width: 16, marginLeft: 8 }} />
//                   </td>
//                   <td className="Heading-tc" style={{ textAlign: "left" }}>
//                     {visibleColumns[3] || "Reports"}
//                     <img src={updown} onClick={() => handleSort(visibleColumns[3] || "Reports")} alt="sort" style={{ height: 16, width: 16, marginLeft: 8 }} />
//                   </td>
//                 </tr>
//               </thead>

//               <tbody>
//                 {paginatedData.map((groupRow, groupIndex) => {
//                   const roles = groupRow.roles || [];
//                   const rowCount = roles.length || 1;
//                   const groupRowClass = groupIndex % 2 === 1 ? "even-row-tc" : "";

//                   if (roles.length === 0) {
//                     return (
//                       <tr key={groupIndex} className={groupRowClass} style={{ borderBottom: "1px solid #EEE" }}>
//                         <td style={{ textAlign: "left", verticalAlign: "top", color: "#6A6A6A", paddingLeft: 20 }}>
//                           <Link to="#" onClick={(e) => { e.preventDefault(); openGroupModal(groupRow); }} style={{ color: "#337AB7"}}>
//                             {groupRow.group_name}
//                           </Link>
//                         </td>
//                         <td style={{ textAlign: "left", verticalAlign: "top", color: "#6A6A6A" }}>No roles</td>
//                         <td style={{ textAlign: "left", verticalAlign: "top", color: "#6A6A6A" }}>No screens</td>
//                         <td style={{ textAlign: "left", verticalAlign: "top", color: "#6A6A6A" }}>No reports</td>
//                       </tr>
//                     );
//                   }

//                   return roles.map((role, ri) => {
//                     const isFirstRoleRow = ri === 0;
//                     const trKey = `${groupIndex}-${ri}`;

//                     return (
//                       <tr key={trKey} className={groupRowClass} style={{ borderBottom: "1px solid #EEE" }}>
//                         {isFirstRoleRow && (
//                           <td rowSpan={rowCount} style={{ textAlign: "left", verticalAlign: "middle", color: "#6A6A6A", paddingLeft: 20, width: "18%" }}>
//                             <Link to="#" onClick={(e) => { e.preventDefault(); openGroupModal(groupRow); }} style={{ color: "#337AB7" }}>
//                               {groupRow.group_name}
//                             </Link>
//                           </td>
//                         )}

//                         <td style={{ textAlign: "left", verticalAlign: "top", color: "#6A6A6A", width: "22%", paddingLeft: 8 }}>
//                           <div className="uge-role-column" style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
//                             <Link to="#" onClick={(e) => { e.preventDefault(); openRoleModal(groupRow, role); }} style={{ color: "#337AB7",  marginBottom: 6 }}>
//                               {role.role_name}
//                             </Link>
//                           </div>
//                         </td>

//                         {/* Screens column: ensure inline style overrides the global td > div.
//                             We call renderAccess(..., compact=true) so the first bubble has a small gap */}
//                         <td style={{ textAlign: "left", verticalAlign: "top", color: "#6A6A6A", width: "35%" }}>
//   <div
//     className="uge-screens-cell"
//     style={{
//       display: "flex",
//       flexDirection: "column",
//       gap: 6,
//       alignItems: "flex-start",
//     }}
//   >
//     {(role.screens && role.screens.length > 0) ? (
//       role.screens.map((s, si) => (
//         <div
//           key={si}
//           className="uge-screen-row"
//           style={{
//             display: "flex",
//             alignItems: "center",
//             flexWrap: "nowrap",
//           }}
//         >
//           <div
//             className="screen-text"
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               whiteSpace: "nowrap",
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//               maxWidth: "100%",
//               paddingTop: 2,
//               gap: 4, // small space between text and first bubble
//             }}
//           >
//             <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
//               {s.screen_name}
//             </span>
//             {renderAccess(s.access, false, true)}
//           </div>
//         </div>
//       ))
//     ) : (
//       <div style={{ color: "#999" }}>No screens</div>
//     )}
//   </div>
// </td>


//                         {/* reports column - stacked. We call renderAccess(..., true, compact=true) so the report
//                             name and bubbles appear side-by-side with a small gap */}
//                         <td style={{ textAlign: "left", verticalAlign: "top", color: "#6A6A6A", width: "25%" }}>
//                           <div
//                             className="uge-reports-cell"
//                             style={{
//                               display: "flex",
//                               flexDirection: "column",
//                               gap: 6,
//                               alignItems: "flex-start", // inline override
//                             }}
//                           >
//                             {(role.reports && role.reports.length > 0) ? (
//                               role.reports.map((r, ri2) => (
//                                 <div
//                                   key={ri2}
//                                   className="uge-report-row"
//                                   style={{
//                                     display: "flex", // inline override
//                                     alignItems: "flex-start", // inline override
//                                     gap: 12,
//                                   }}
//                                 >
//                                   <div
//                                     className="report-text"
//                                     style={{
//                                       minWidth: 180,
//                                       whiteSpace: "nowrap",
//                                       overflow: "hidden",
//                                       textOverflow: "ellipsis",
//                                       paddingTop: 2,
//                                       display: "inline-flex",
//                                       alignItems: "center",
//                                       gap: 0, // text + bubbles are inside, we control gap by AccessBubble margin
//                                     }}
//                                   >
//                                     <span style={{ display: "inline-block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{r.report_name}</span>
//                                     {renderAccess(r.access, /* isReport */ true, /* compact */ true)}
//                                   </div>
//                                 </div>
//                               ))
//                             ) : (
//                               <div style={{ color: "#999" }}>No reports</div>
//                             )}
//                           </div>
//                         </td>
//                       </tr>
//                     );
//                   });
//                 })}
//               </tbody>
//             </table>
//           </div>

//           {/* <div className="pagination-tc" style={{ marginTop: 12 }}>
//             <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1} className="extreme-left-tc-pagination"><img src={leftArrow} alt="" /></button>
//             <button onClick={() => setCurrentPage((p) => Math.max(1, p - 1))} disabled={currentPage === 1} className="lefttc-pagination">{"<"}</button>
//             {Array.from({ length: totalPages }).map((_, i) => (
//               <button key={i + 1} onClick={() => setCurrentPage(i + 1)} className={currentPage === i + 1 ? "active" : ""}>{i + 1}</button>
//             ))}
//             <button onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages} className="righttc-pagination">{">"}</button>
//             <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} className="extreme-right-tc-pagination"><img src={rightArrow} alt="" /></button>
//           </div> */}
//         </>
//       ) : (
//         "No data available"
//       )}

//       {/* Details modal */}
//       {detailsModal.visible && (
//         <div className="modal-overlay" style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1200, display: "flex", alignItems: "center", justifyContent: "center" }} onClick={closeDetailsModal}>
//           <div className="modal-content" style={{ width: 760, maxHeight: "80vh", overflowY: "auto", background: "#fff", borderRadius: 8, padding: 18 }} onClick={(e) => e.stopPropagation()}>
//             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
//               <h3 style={{ margin: 0, fontSize: 18 }}>{detailsModal.type === "group" ? `User Group: ${detailsModal.payload.group_name}` : `Role: ${detailsModal.payload.role_name}`}</h3>
//               <button onClick={closeDetailsModal} style={{ background: "none", border: "none", fontSize: 18, cursor: "pointer" }}>✕</button>
//             </div>

//             {detailsModal.type === "group" && (
//               <div>
//                 {(detailsModal.payload.roles || []).map((role, idx) => (
//                   <div key={idx} style={{ borderBottom: "1px solid #EEE", padding: "10px 0" }}>
//                     <div style={{ fontWeight: 700, marginBottom: 6, color: "#337AB7"}}>{role.role_name}</div>

//                     <div style={{ marginBottom: 6 }}>
//                       <div style={{ fontSize: 13, color: "#6A6A6A", marginBottom: 6 }}>Screens</div>
//                       {(role.screens || []).map((s, si) => (
//                         <div key={si} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
//                           <div style={{ minWidth: 180 }}>{s.screen_name}</div>
//                           <div>{renderAccess(s.access)}</div>
//                         </div>
//                       ))}
//                       {(!role.screens || role.screens.length === 0) && <div style={{ color: "#999" }}>No screens</div>}
//                     </div>

//                     <div>
//                       <div style={{ fontSize: 13, color: "#6A6A6A", marginBottom: 6 }}>Reports</div>
//                       {(role.reports || []).map((r, ri) => (
//                         <div key={ri} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
//                           <div style={{ minWidth: 180 }}>{r.report_name}</div>
//                           <div>{renderAccess(r.access, true)}</div>
//                         </div>
//                       ))}
//                       {(!role.reports || role.reports.length === 0) && <div style={{ color: "#999" }}>No reports</div>}
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             )}

//             {detailsModal.type === "role" && (
//               <div>
//                 <div style={{ marginBottom: 6 }}>
//                   <div style={{ fontSize: 13, color: "#6A6A6A", marginBottom: 6 }}>Screens</div>
//                   {(detailsModal.payload.screens || []).map((s, si) => (
//                     <div key={si} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
//                       <div style={{ minWidth: 180 }}>{s.screen_name}</div>
//                       <div>{renderAccess(s.access)}</div>
//                     </div>
//                   ))}
//                   {(!detailsModal.payload.screens || detailsModal.payload.screens.length === 0) && <div style={{ color: "#999" }}>No screens</div>}
//                 </div>

//                 <div>
//                   <div style={{ fontSize: 13, color: "#6A6A6A", marginBottom: 6 }}>Reports</div>
//                   {(detailsModal.payload.reports || []).map((r, ri) => (
//                     <div key={ri} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
//                       <div style={{ minWidth: 180 }}>{r.report_name}</div>
//                       <div>{renderAccess(r.access, true)}</div>
//                     </div>
//                   ))}
//                   {(!detailsModal.payload.reports || detailsModal.payload.reports.length === 0) && <div style={{ color: "#999" }}>No reports</div>}
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default TableForUserEdit;



















// TableForUserEdit.jsx
import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import updown from "../../Assets/Images/CommanImages/updown.png";
import Filter from "../../Assets/Images/CommanImages/filter.png";
import leftArrow from "../../Assets/Images/CommanImages/Larrowbar.png";
import rightArrow from "../../Assets/Images/CommanImages/Rarrowbar.png";
import "katex/dist/katex.min.css";
import searchicon from "../../Assets/Images/CommanImages/searchyellow.png";

/**
 * TableForUserEdit: grouped user-group table.
 * - Group cell uses rowspan = number of roles
 * - One <tr> per role (so screens/reports for a role are grouped)
 * - Modal shows group (tabular) or role (only screens & reports)
 * - Bubbles have tooltips; DL changed to E (Export)
 * - Minimal inline style overrides applied only for screens/reports containers
 */

const bubbleTitleMap = {
  R: "Read",
  U: "Update",
  D: "Delete",
  C: "Create",
  P: "Print",
  E: "Export",
};

const AccessBubble = ({ letter, title, visible, color, small = true, margin }) => {
  if (!visible) return null;
  const size = small ? 20 : 22;
  const effectiveTitle = title || bubbleTitleMap[letter] || letter;
  const style = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: `${size}px`,
    height: `${size}px`,
    borderRadius: "50%",
    marginLeft: typeof margin === "number" ? margin : 6,
    fontSize: small ? 11 : 12,
    color: "#fff",
    fontWeight: 700,
    backgroundColor: color,
    lineHeight: 1,
    flex: "0 0 auto",
    cursor: "default",
  };
  return (
    <span
      className={`uge-bubble uge-bubble-${letter}`}
      title={effectiveTitle}
      aria-label={effectiveTitle}
      style={style}
    >
      {letter}
    </span>
  );
};

/**
 * renderAccess(access, isReport, compact)
 * - compact true reduces the gap between text and first bubble (used inside table cell inline)
 * - For download access boolean, we render letter "E" (Export) instead of DL.
 */
// const renderAccess = (access, isReport = false, compact = false) => {
//   if (!access) return null;
//   const firstGap = compact ? 6 : 8; // reduce slightly for compact usage
//   return (
//     <div
//       className="uge-bubble-container"
//       style={{
//         display: "flex",
//         alignItems: "center",
//         gap: 6,
//         flexWrap: "nowrap",
//       }}
//     >
//       {!isReport && <AccessBubble letter="R" visible={!!access.read} color="#19B24B" margin={firstGap} />}
//       {!isReport && <AccessBubble letter="U" visible={!!access.update} color="#FF9800" margin={firstGap} />}
//       {!isReport && <AccessBubble letter="D" visible={!!access.delete} color="#E53935" margin={firstGap} />}
//       {!isReport && <AccessBubble letter="C" visible={!!access.create} color="#C3EA3D" margin={firstGap} />}
//       <AccessBubble letter="P" visible={!!access.print} color="#25A9E0" margin={firstGap} />
//       {/* show E (Export) instead of DL */}
//       <AccessBubble letter="E" visible={!!access.download} color="#7E8DA6" margin={firstGap} />
//     </div>
//   );
// };

// replace the old renderAccess with this
const renderAccess = (access, isReport = false, compact = false) => {
  if (!access) return null;
  const firstGap = compact ? 6 : 8; // reduce slightly for compact usage

  // fixed display order: C R U D P E (CRUDPE)
  const order = ["C", "R", "U", "D", "P", "E"];

  // map letter -> access prop name
  const propMap = {
    C: "create",
    R: "read",
    U: "update",
    D: "delete",
    P: "print",
    E: "download",
  };

  // colors for each bubble (use your original palette)
  const colorMap = {
    R: "#19B24B",
    U: "#FF9800",
    D: "#E53935",
    C: "#C3EA3D",
    P: "#25A9E0",
    E: "#7E8DA6",
  };

  return (
    <div
      className="uge-bubble-container"
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        flexWrap: "nowrap",
      }}
    >
      {order.map((letter, idx) => {
        // for report rows, keep the same behavior as before: don't show CRUD for reports
        if (isReport && ["C", "R", "U", "D"].includes(letter)) {
          return null;
        }

        const prop = propMap[letter];
        const visible = !!access[prop];
        if (!visible) return null;

        // first visible bubble should use 'firstGap' as left margin, others use regular margin
        const margin = firstGap;

        return (
          <AccessBubble
            key={letter}
            letter={letter}
            visible={true}
            color={colorMap[letter]}
            small={true}
            margin={margin}
          />
        );
      })}
    </div>
  );
};


const TableForUserEdit = ({
  headers = [],
  data = [],
  searchPlaceholder = "Search...",
  selectedRows = [],
  setSelectedRows = () => {},
  renderQuestionText = (t) => t,
  renderQuestionTextModel = (t) => t,
  expandedStates = {},
  toggleImage = () => {},
  questionDetailsMap = {},
  handleEyeClick = () => {},
  pageType = "default",
  onRowLinkClick = () => {},
  filterConfig = {},
  handleDeleteRow = () => {},
  disabled = false,
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    if (headers.length > 0 && visibleColumns.length === 0) setVisibleColumns([...headers]);
  }, [headers, visibleColumns.length]);

  const rowToString = (row) => {
    if (!row) return "";
    return [
      row.group_name,
      ...(row.roles || []).flatMap((r) => [r.role_name, ...(r.screens || []).map((s) => s.screen_name), ...(r.reports || []).map((rp) => rp.report_name)]),
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
  };

  const filteredData = data.filter((row) => {
    const text = rowToString(row);
    return !searchQuery || text.includes(searchQuery.toLowerCase());
  });

  const sortedData = useMemo(() => {
    let arr = [...filteredData];
    if (sortConfig.key) {
      arr.sort((a, b) => {
        const getVal = (r) => (sortConfig.key === "User Groups" ? r.group_name : (r.roles || []).map((x) => x.role_name).join(", "));
        const va = getVal(a);
        const vb = getVal(b);
        if (va < vb) return sortConfig.direction === "asc" ? -1 : 1;
        if (va > vb) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
      });
    }
    return arr;
  }, [filteredData, sortConfig]);

  const totalPages = Math.max(1, Math.ceil(sortedData.length / pageSize));
  const paginatedData = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return sortedData.slice(start, start + pageSize);
  }, [sortedData, currentPage, pageSize]);

  const handleSort = (column) => {
    let dir = "asc";
    if (sortConfig.key === column && sortConfig.direction === "asc") dir = "desc";
    setSortConfig({ key: column, direction: dir });
  };

  // modal state: { visible, type: 'group'|'role', payload: <object> }
  const [detailsModal, setDetailsModal] = useState({ visible: false, type: null, payload: null });
  const openGroupModal = (groupRow) => setDetailsModal({ visible: true, type: "group", payload: groupRow });
  const openRoleModal = (groupRow, roleObj) => setDetailsModal({ visible: true, type: "role", payload: { ...roleObj, group_name: groupRow.group_name } });
  const closeDetailsModal = () => setDetailsModal({ visible: false, type: null, payload: null });

  // helper to render the inline "text + bubbles" container used for both screens and reports
  const InlineNameWithBubbles = ({ name, access, compact = false }) => {
    return (
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "100%",
        }}
        title={name}
      >
        <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{name}</span>
        {access ? renderAccess(access, false, compact) : null}
      </div>
    );
  };

  return (
    <div className="uge-table-wrapper" style={{ width: "100%" }}>
      {/* top controls */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "10px", marginTop: "10px" }}>
        <div style={{ display: "flex", alignItems: "center", width: "490px" }} />
        <div style={{ textAlign: "end", color: "#424242" }}>
          Displaying {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} - {Math.min(currentPage * pageSize, sortedData.length)} of {sortedData.length} records |
          {["10", "25", "50", "100", "500"].map((size) => (
            <span
              key={size}
              onClick={() => { setPageSize(Number(size)); setCurrentPage(1); }}
              style={{ cursor: "pointer", margin: "0 5px", textDecoration: size === String(pageSize) ? "none" : "underline", color: size === String(pageSize) ? "black" : "#337AB7" }}
            >
              {size}
            </span>
          ))}
        </div>
      </div>

      {/* <div style={{ display: "flex", backgroundColor: "#D6D6D6", marginTop: 9, borderTop: "1px solid grey", borderBottom: "1px solid grey" }}>
        <div style={{ backgroundColor: "#FFBD20", display: "flex", alignItems: "center", paddingLeft: 8, width: 90 }}>
          <img src={Filter} style={{ height: 24, width: 24 }} alt="filter" />
          <span style={{ marginLeft: 10, color: "#2F2E40" }}>Filter</span>
        </div>
        <div style={{ marginLeft: "auto", marginRight: 8, display: "flex", alignItems: "center", position: "relative", height: 40 }}>
          <img src={searchicon} alt="search" style={{ cursor: "pointer" }} />
        </div>
      </div> */}

      {data.length > 0 ? (
        <>
          <div className="table-wrapper-cols-selections" style={{ overflowX: "auto", width: "100%" }}>
            <table className="table-tc" style={{ width: "100%", borderCollapse: "separate" }}>
              <thead>
                <tr>
                  <td className="Heading-tc" style={{ textAlign: "left", paddingLeft: 20, backgroundColor: "#ebebebff" }}>
                    {visibleColumns[0] || "User Groups"}
                    <img src={updown} onClick={() => handleSort(visibleColumns[0] || "User Groups")} alt="sort" style={{ height: 16, width: 16, marginLeft: 8 }} />
                  </td>
                  <td className="Heading-tc" style={{ textAlign: "left", backgroundColor: "#ebebebff" }}>
                    {visibleColumns[1] || "Roles"}
                    <img src={updown} onClick={() => handleSort(visibleColumns[1] || "Roles")} alt="sort" style={{ height: 16, width: 16, marginLeft: 8 }} />
                  </td>
                  <td className="Heading-tc" style={{ textAlign: "left", backgroundColor: "#ebebebff" }}>
                    {visibleColumns[2] || "Screens"}
                    <img src={updown} onClick={() => handleSort(visibleColumns[2] || "Screens")} alt="sort" style={{ height: 16, width: 16, marginLeft: 8 }} />
                  </td>
                  <td className="Heading-tc" style={{ textAlign: "left", backgroundColor: "#ebebebff" }}>
                    {visibleColumns[3] || "Reports"}
                    <img src={updown} onClick={() => handleSort(visibleColumns[3] || "Reports")} alt="sort" style={{ height: 16, width: 16, marginLeft: 8 }} />
                  </td>
                </tr>
              </thead>

              <tbody>
                {paginatedData.map((groupRow, groupIndex) => {
                  const roles = groupRow.roles || [];
                  const rowCount = Math.max(roles.length, 1);
                  const groupRowClass = groupIndex % 2 === 1 ? "even-row-tc" : "";

                  if (roles.length === 0) {
                    return (
                      <tr key={groupIndex} className={groupRowClass} style={{ borderBottom: "1px solid #EEE" }}>
                        <td style={{ textAlign: "left", verticalAlign: "top", color: "#6A6A6A", paddingLeft: 20 }}>
                          <Link to="#" onClick={(e) => { e.preventDefault(); openGroupModal(groupRow); }} style={{ color: "#337AB7" }}>
                            {groupRow.group_name}
                          </Link>
                        </td>
                        <td style={{ textAlign: "left", verticalAlign: "top", color: "#6A6A6A" }}>-</td>
                        <td style={{ textAlign: "left", verticalAlign: "top", color: "#6A6A6A" }}>-</td>
                        <td style={{ textAlign: "left", verticalAlign: "top", color: "#6A6A6A" }}>-</td>
                      </tr>
                    );
                  }

                  return roles.map((role, ri) => {
                    const isFirstRoleRow = ri === 0;
                    const trKey = `${groupIndex}-${ri}`;

                    return (
                      <tr key={trKey} className={groupRowClass} style={{ borderBottom: "1px solid #EEE" }}>
                        {isFirstRoleRow && (
                          <td rowSpan={rowCount} style={{ textAlign: "left", verticalAlign: "middle", color: "#6A6A6A", paddingLeft: 20, width: "18%" }}>
                            <Link to="#" onClick={(e) => { e.preventDefault(); openGroupModal(groupRow); }} style={{ color: "#337AB7" }}>
                              {groupRow.group_name}
                            </Link>
                          </td>
                        )}

                        <td style={{ textAlign: "left", verticalAlign: "top", color: "#6A6A6A", width: "22%", paddingLeft: 8 }}>
                          <div className="uge-role-column" style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                            <Link to="#" onClick={(e) => { e.preventDefault(); openRoleModal(groupRow, role); }} style={{ color: "#337AB7", marginBottom: 6 }}>
                              {role.role_name}
                            </Link>
                          </div>
                        </td>

                        {/* Screens column */}
                        <td style={{ textAlign: "left", verticalAlign: "top", color: "#6A6A6A", width: "35%" }}>
                          <div
                            className="uge-screens-cell"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 6,
                              alignItems: "flex-start",
                            }}
                          >
                            {(role.screens && role.screens.length > 0) ? (
                              role.screens.map((s, si) => (
                                <div
                                  key={si}
                                  className="uge-screen-row"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    flexWrap: "nowrap",
                                    gap: 12,
                                    width: "100%",
                                  }}
                                >
                                  {/* Inline name + bubbles inside the same div so they stay together */}
                                  <div style={{ display: "flex", alignItems: "center", gap: 8, width: "100%", justifyContent: "flex-start" }}>
                                    <div style={{ minWidth: 260, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                      <InlineNameWithBubbles name={s.screen_name} access={s.access} compact={true} />
                                    </div>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div style={{ color: "#999" }}>-</div>
                            )}
                          </div>
                        </td>

                        {/* Reports column */}
                        <td style={{ textAlign: "left", verticalAlign: "top", color: "#6A6A6A", width: "25%" }}>
                          <div
                            className="uge-reports-cell"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 6,
                              alignItems: "flex-start",
                              width: "100%",
                            }}
                          >
                            {(role.reports && role.reports.length > 0) ? (
                              role.reports.map((r, ri2) => (
                                <div
                                  key={ri2}
                                  className="uge-report-row"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 12,
                                    width: "100%",
                                  }}
                                >
                                  <div style={{ minWidth: 180, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                      <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{r.report_name}</span>
                                      {renderAccess(r.access, true, true)}
                                    </div>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div style={{ color: "#999" }}>-</div>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  });
                })}
              </tbody>
            </table>
          </div>

          {/* Keep original pagination UI but commented out (per your request) */}
          
          <div className="pagination-tc" style={{ marginTop: 12 }}>
            <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1} className="extreme-left-tc-pagination"><img src={leftArrow} alt="" /></button>
            <button onClick={() => setCurrentPage((p) => Math.max(1, p - 1))} disabled={currentPage === 1} className="lefttc-pagination">{"<"}</button>
            {Array.from({ length: totalPages }).map((_, i) => (
              <button key={i + 1} onClick={() => setCurrentPage(i + 1)} className={currentPage === i + 1 ? "active" : ""}>{i + 1}</button>
            ))}
            <button onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages} className="righttc-pagination">{">"}</button>
            <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} className="extreme-right-tc-pagination"><img src={rightArrow} alt="" /></button>
          </div>
         
        </>
      ) : (
        "No data available"
      )}

      {/* Details modal */}
      {detailsModal.visible && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.45)",
            zIndex: 1200,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 12,
          }}
          onClick={closeDetailsModal}
        >
          <div
            className="modal-content"
            role="dialog"
            aria-modal="true"
            style={{
              width: "min(1100px, 95vw)",
              maxWidth: "95vw",
              maxHeight: "85vh",
              overflowY: "auto",
              background: "#fff",
              borderRadius: 6,
              padding: 18,
              boxSizing: "border-box",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
              <h3 style={{ margin: 0, fontSize: 18, color: "#6A6A6A" }}>
                {detailsModal.type === "group"
                  ? `User Group: ${detailsModal.payload.group_name}`
                  : `Role: ${detailsModal.payload.role_name}`}
              </h3>
              <button onClick={closeDetailsModal} style={{ background: "none", border: "none", fontSize: 18, cursor: "pointer" }}>✕</button>
            </div>

            {/* If group: show tabular layout (Role | Screens | Reports) similar to table */}
            {detailsModal.type === "group" && (
              <div style={{ width: "100%" }}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr 2fr", gap: 12, fontWeight: 700, padding: "8px 0", borderBottom: "1px solid #EEE", color: "#6A6A6A" }}>
                  <div>Role</div>
                  <div>Screens</div>
                  <div>Reports</div>
                </div>

                {(detailsModal.payload.roles || []).map((role, idx) => (
                  <div key={idx} style={{ borderBottom: "1px solid #F1F1F1", padding: "10px 0" }}>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr 2fr", gap: 12, alignItems: "start" }}>
                      {/* <div style={{ color: "#337AB7", fontWeight: 600 }}>{role.role_name}</div> */}
                      <div style={{ color: "#6A6A6A" }}>{role.role_name}</div>

                      <div>
                        {(role.screens && role.screens.length > 0) ? (
                          role.screens.map((s, si) => (
                            <div key={si} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6 }}>
                              <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", minWidth: 180, color: "#6A6A6A"}}>{s.screen_name}</div>
                              <div>{renderAccess(s.access)}</div>
                            </div>
                          ))
                        ) : (
                          <div style={{ color: "#999" }}>-</div>
                        )}
                      </div>

                      <div>
                        {(role.reports && role.reports.length > 0) ? (
                          role.reports.map((r, ri) => (
                            <div key={ri} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6 }}>
                              <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", minWidth: 180, color: "#6A6A6A"}}>{r.report_name}</div>
                              <div>{renderAccess(r.access, true)}</div>
                            </div>
                          ))
                        ) : (
                          <div style={{ color: "#999" }}>-</div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* If role: show only that role's screens & reports (two columns) */}
            {detailsModal.type === "role" && (
              <div style={{ width: "100%" }}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, fontWeight: 700, padding: "8px 0", borderBottom: "1px solid #EEE", color: "#6A6A6A" }}>
                  <div>Screens</div>
                  <div>Reports</div>
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, paddingTop: 10 }}>
                  <div>
                    {(detailsModal.payload.screens && detailsModal.payload.screens.length > 0) ? (
                      detailsModal.payload.screens.map((s, si) => (
                        <div key={si} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
                          <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", minWidth: 180, color: "#6A6A6A" }}>{s.screen_name}</div>
                          <div>{renderAccess(s.access)}</div>
                        </div>
                      ))
                    ) : (
                      <div style={{ color: "#999" }}>-</div>
                    )}
                  </div>

                  <div>
                    {(detailsModal.payload.reports && detailsModal.payload.reports.length > 0) ? (
                      detailsModal.payload.reports.map((r, ri) => (
                        <div key={ri} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
                          <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", minWidth: 180, color: "#6A6A6A" }}>{r.report_name}</div>
                          <div>{renderAccess(r.access, true)}</div>
                        </div>
                      ))
                    ) : (
                      <div style={{ color: "#999" }}>-</div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default TableForUserEdit;


